import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardPowerState } from '@api/ruStatusDashboard';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_POWER_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusPowerState {
	ruDashboardStatusPowerState: TSelectOption<string>[];
	isLoadingRUDashboardStatusPower: boolean;
}

export const useQueryRUDashboardStatusPowerState = (): IUseQueryRUDashboardStatusPowerState => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_POWER_STATE],
		queryFn: getRUStatusDashboardPowerState,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusPowerState: data || [],
		isLoadingRUDashboardStatusPower: isInitialLoading,
	};
};
